/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { enviroment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GestionHumanaService {
  constructor(private httpClient: HttpClient) {}

  async getGestionHumana(idColaborador: number, fechaInicio: string, fechaFin: string): Promise<any> {
    const url = `${enviroment.url}sap/gestionhumana?idColaborador=${idColaborador}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
    return firstValueFrom<any>(this.httpClient.get<any>(url));
  }
}
